import React, { useState } from 'react';
import './TradeSystem.scss';
import product_A from '../../assets/tradeImages/trade_1.png';
import product_B from '../../assets/tradeImages/trade_2.png';
import product_C from '../../assets/tradeImages/trade_3.png';
import product_D from '../../assets/tradeImages/trade_4.png';
import product_E from '../../assets/tradeImages/trade_5.png';
import trade_A from '../../assets/tradeImages/trade_6_1.png';
import trade_B from '../../assets/tradeImages/trade_7.png';
import trade_C from '../../assets/tradeImages/trade_8.png';
import trade_D from '../../assets/tradeImages/trade_9.png';
import advantage_A from '../../assets/tradeImages/trade_10.png';
import advantage_B from '../../assets/tradeImages/trade_11.png';
import advantage_C from '../../assets/tradeImages/trade_12.png';

import trade_A_a from '../../assets/tradeImages/trade_6_2.png';
import trade_B_b from '../../assets/tradeImages/trade_7_2.png';
import trade_C_c from '../../assets/tradeImages/trade_8_2.png';
import trade_D_d from '../../assets/tradeImages/trade_9_2.png';
import advantage_A_a from '../../assets/tradeImages/trade_10_2.png';
import advantage_B_b from '../../assets/tradeImages/trade_11_2.png';
import advantage_C_c from '../../assets/tradeImages/trade_12_2.png';
import angryLittleGirl from '../../assets/angryLittleGirl.png';

const TradeSystem = () => {
  const supplySoftwareIntroductionText =
    '挚云数科供应链金融系统借助互联网、大数据征信、人工智能等信息技术，依托于核心企业的交易过程，以中小企业的订单、物流、融资、仓储等经营性行为，作为融资手段，通过交易数据提取及分析，实现授信及融资；系统以场景+金融为出发点，支持供应链业务中不同业务形态需求。同时系统可对接多种平台服务，保障系统的智能、安全、高效运行。';
  const [isShow, setIsShow] = useState(null);
  const styleDl = {
    color: '#fff',
    background: '#3676ff',
  };
  const [productArr, setProductArr] = useState([
    {
      id: 1,
      img: product_A,
      text: '高达明星产品 贸易商务平台',
    },
    {
      id: 2,
      img: product_B,
      text: '凝结了多家 客户的成功实施经验',
    },
    {
      id: 3,
      img: product_C,
      text: '升级全新内核系统， 速度更快,更稳定,数据不出错',
    },
    {
      id: 4,
      img: product_D,
      text: '更全能,全平台覆盖， 更多功能亮点',
    },
    {
      id: 5,
      img: product_E,
      text: '移动商务与电商互联互通 功能更强大,操作更简便',
    },
  ]);

  const [tradeList, setTradeList] = useState([
    {
      id: 1,
      img: trade_A,
      newImg: trade_A_a,
      isShow: true,
      title: '全流程一体化，跨部门间高效 协作,提升运营效率',
      word: `建立以业务为导向，把销售、采购、财务各个部门流程串通起来，提高各部门协同效率，让各个环节高效运转从而提升企业的整体运营效率。`,
    },
    {
      id: 2,
      img: trade_B,
      newImg: trade_B_b,
      isShow: true,
      title: '精细化管理，流程化执行，高效对账',
      word: `系统支持一键制单，同时可对接企业ERP系统推送账单，无需财务人员花费大量时间制作、核对账单，提升对账效率，协助企业在周期内及时作出对账响应。`,
    },
    {
      id: 3,
      img: trade_C,
      newImg: trade_C_c,
      isShow: true,
      title: '降低库存成本，提升库存周转率',
      word: `全流程管理，实现入库、出库、发货等全流程智能管理，即时数据自动更新，快捷准确，减少人为误差。`,
    },
    {
      id: 4,
      img: trade_D,
      newImg: trade_D_d,
      isShow: true,
      title: '帮助企业实现业财一体，经营数据可视化',
      word: `通过业务流程的系统化高效落地，提高效率的同时，还可以实现业财一体，以及经营数据的可视化，从运营能力、盈利能力、偿债能力等方面建立可视化模型与分析，帮助企业实现数字化转型。`,
    },
  ]);
  const [advantageList, setAdvantageList] = useState([
    {
      id: 1,
      img: advantage_A,
      newImg: advantage_A_a,
      isShow: true,
      title: '系统优势 ',
      text: '系统支持自定义参数设置,简化业务 流程,多维度征信评估,全流程智能化 风控标准,有效降低坏账率。',
    },
    {
      id: 2,
      img: advantage_B,
      newImg: advantage_B_b,
      isShow: true,
      title: '性能优势',
      text: '支持多类业务产品需求,和产品更新迭 代,系统扩展性强且满足各类负载均衡 策略要求。数据备份处理,有效避免数 据遗失。',
    },
    {
      id: 3,
      img: advantage_C,
      newImg: advantage_C_c,
      isShow: true,
      title: '安全优势',
      text: '系统采用(springbootadmin)架构对 应用进行监听,完整的菜单权限与数据权 限机制,有效保障系统、数据安全。',
    },
  ]);
  const handleMouseEnter = (img) => {
    setIsShow(img);
  };
  const handleMouseLeave = (img) => {
    setIsShow(null);
  };
  return (
    <div className="tradeSystem">
      <div className="supply-software">
        <div className="tradeSystem-title-weight">
          <div className="title-ch">贸易系统软件介绍</div>
          <div className="title-en">INTRODUCTION TO TRADE SYSTEM SOFTWARE</div>
          <div className="horizontal-line" />
        </div>
        <div className="supply-software-introduction">
          <div className="supply-software-introduction-img">
            <img src={angryLittleGirl} alt="" />
          </div>
          <div className="supply-software-introduction-text">
            {supplySoftwareIntroductionText}
          </div>
        </div>
      </div>
      <div className="tradeSystem-software">
        <div className="tradeSystem-title-weight">
          <div className="title-ch">产品亮点</div>
          <div className="title-en">PRODUCT HIGHLIGHTS</div>
          <div className="horizontal-line" />
        </div>
        <div className="product-bright">
          {productArr.map((item, ind) => {
            return (
              <dl key={item.id}>
                <dt>
                  <img src={item.img} alt="" />
                </dt>
                <dd>{item.text}</dd>
              </dl>
            );
          })}
        </div>
      </div>

      <div className="tradeSystem-peculiarity">
        <div className="tradeSystem-title-weight">
          <div className="title-ch">系统特点</div>
          <div className="title-en">SYSTEM CHARACTERISTICS</div>
          <div className="horizontal-line" />
        </div>
        <div className="tradeSystem-peculiarity-center">
          {tradeList.map((item, ind) => {
            return (
              <dl
                className="tradeSystem-peculiarity-center-dl"
                key={item.id}
                onMouseEnter={() => handleMouseEnter(item.img)}
                onMouseLeave={() => handleMouseLeave(item.img)}
                style={isShow === item.img ? styleDl : null}
              >
                <dt className="tradeSystem-peculiarity-center-dt ">
                  <img
                    src={isShow === item.img ? item.newImg : item.img}
                    alt=""
                  />
                </dt>
                <div className="tradeSystem-peculiarity-center-title">
                  {item.title}
                </div>
                <div className="short-stick"></div>
                <div className="long-stick "></div>
                <div className="tradeSystem-peculiarity-center-word">
                  {item.word}
                </div>
              </dl>
            );
          })}
        </div>
      </div>

      <div className="advantage">
        <div className="tradeSystem-title-weight">
          <div className="title-ch">系统优势</div>
          <div className="title-en">SYSTEM ADVANTAGES</div>
          <div className="horizontal-line" />
        </div>
        <div className="advantageList">
          {advantageList.map((item) => {
            return (
              <dl
                className="advantageList_dl"
                key={item.id}
                onMouseEnter={() => handleMouseEnter(item.img)}
                onMouseLeave={() => handleMouseLeave(item.img)}
                style={isShow === item.img ? styleDl : null}
              >
                <dt className="advantageList_dt">
                  <img
                    src={isShow === item.img ? item.newImg : item.img}
                    alt=""
                  />
                </dt>
                <div className="advantageList_dd">
                  <dd className="advantageList_dd_title">{item.title}</dd>
                  <dd className="advantageList_dd_text">{item.text}</dd>
                </div>
              </dl>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TradeSystem;
